import { useRef, useState } from "react";

export default function useActionLock() {
  const locked = useRef(false);
  const [busy, setBusy] = useState(false);
  const run = async (operation) => {
    if (locked.current) return;
    locked.current = true;
    setBusy(true);
    try { return await operation(); }
    finally { locked.current = false; setBusy(false); }
  };
  return [busy, run];
}
